import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { prepareHeaders } from './utils';
import { LogDeviceWhitelist } from '../features/app/context/log-device-whitelist/components/LogDeviceWhitelistForm';
import { config } from '../config';
import { DEVICE_TYPE } from '../features/app/context/device-sidebar/device-state.types';

const REQUEST_MAPPING = '/log-device-whitelist';
const TAG = 'LogDeviceWhitelist';

const transformInput = (logDeviceWhitelist: LogDeviceWhitelist) => ({
    ...logDeviceWhitelist,
    type: logDeviceWhitelist.type.toLowerCase(),
});

export const logDeviceWhitelistOcu3Api = createApi({
    reducerPath: 'logDeviceWhitelistOcu3',
    tagTypes: [TAG],
    baseQuery: fetchBaseQuery({
        baseUrl: config.backend.DEVICE_STATE_MBB_BASE,
        prepareHeaders,
    }),
    endpoints: (builder) => ({
        getAllOcu3: builder.query<LogDeviceWhitelist[], void>({
            query: () => REQUEST_MAPPING,
            providesTags: [TAG],
            transformResponse: (response: LogDeviceWhitelist[]) => response.map(item => ({
                ...item,
                type: item.type.toUpperCase() as DEVICE_TYPE,
            })),
        }),
        getOcu3: builder.query<LogDeviceWhitelist, string>({
            query: (device_id) => `${REQUEST_MAPPING}/${device_id}`,
        }),
        addOcu3: builder.mutation<LogDeviceWhitelist[], LogDeviceWhitelist>({
            query: (newLogDeviceWhitelist) => ({
                url: REQUEST_MAPPING,
                method: 'POST',
                body: [transformInput(newLogDeviceWhitelist)],
            }),
            invalidatesTags: [TAG],
        }),
        updateOcu3: builder.mutation<LogDeviceWhitelist[], LogDeviceWhitelist>({
            query: (updatedLogDeviceWhitelist) => ({
                url: REQUEST_MAPPING,
                method: 'PUT',
                body: [transformInput(updatedLogDeviceWhitelist)],
            }),
            invalidatesTags: [TAG],
        }),
        deleteOcu3: builder.mutation<void, string>({
            query: (device_id) => ({
                url: `${REQUEST_MAPPING}/${device_id}`,
                method: 'DELETE',
            }),
            invalidatesTags: [TAG],
        }),
    }),
});

export const {
    useGetAllOcu3Query,
    useGetOcu3Query,
    useAddOcu3Mutation,
    useUpdateOcu3Mutation,
    useDeleteOcu3Mutation,
} = logDeviceWhitelistOcu3Api;